/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Linkdisplayname2Inputs */

const en_entity_linkdisplayname2 = /** @type {(inputs: Entity_Linkdisplayname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Display Name`)
};

const de_entity_linkdisplayname2 = /** @type {(inputs: Entity_Linkdisplayname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link-Anzeigename`)
};

/**
* | output |
* | --- |
* | "Link Display Name" |
*
* @param {Entity_Linkdisplayname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_linkdisplayname2 = /** @type {((inputs?: Entity_Linkdisplayname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Linkdisplayname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_linkdisplayname2(inputs)
	return de_entity_linkdisplayname2(inputs)
});
export { entity_linkdisplayname2 as "entity_linkDisplayName" }